import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";

@Component({
  selector: 'page-report-part',
  templateUrl: 'report-edit-part.html',
})
export class ReportEditPartPage {

  index = 0;
  item: any;
  items = [];
  form: FormGroup;

  datePickerOptions: any = {
    buttons: [{
      text: 'Leeg maken',
      handler: () => {
        this.form.controls['time_manufactured'].setValue(null);
      }
    }]
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public barcodeScanner: BarcodeScanner,
    public viewCtrl: ViewController
  ) {
    this.index = this.navParams.get('index');
    this.item = this.navParams.get('item');
    this.items = this.navParams.get('items');
    this.form = this.formBuilder.group({
      time_manufactured: [(this.item.time_manufactured ? this.item.time_manufactured : '')],
      part_title: [(this.item.part_title ? this.item.part_title : ''), Validators.required],
      part_ean: [(this.item.part_ean ? this.item.part_ean : '')],
      remark: [(this.item.remark ? this.item.remark : '')],
    });
  }

  scanBarcode(field){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if(barcode) this.form.get(field).setValue(barcode);
    }).catch(err => {
      console.log('Error', err);
    });
  }

  save(){
    Object.assign(this.item, this.form.value);
    this.closeModal();
  }

  delete(){
    this.items.splice(this.index, 1);
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportEditPartPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-edit-part/report-edit-part.ts